import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';
import CartToast from './components/CartToast';
import { CartProvider } from './context/CartContext';
import HomePage from './pages/HomePage';
import PanelsPage from './pages/PanelsPage';
import BiomarkersPage from './pages/BiomarkersPage';
import PlatformPage from './pages/PlatformPage';
import HowItWorksPage from './pages/HowItWorksPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import SignInPage from './pages/SignInPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import RefundPage from './pages/RefundPage';
import SubscriptionPage from './pages/SubscriptionPage';
import MedicalDisclaimerPage from './pages/MedicalDisclaimerPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/panels" element={<PanelsPage />} />
          <Route path="/biomarkers" element={<BiomarkersPage />} />
          <Route path="/platform" element={<PlatformPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/order/:id" element={<OrderConfirmationPage />} />
          {/* Backward-compat redirects */}
          <Route path="/features" element={<PlatformPage />} />
          <Route path="/pricing" element={<PanelsPage />} />
          <Route path="/quiz" element={<BiomarkersPage />} />
          {/* Legal */}
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/refund" element={<RefundPage />} />
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/medical-disclaimer" element={<MedicalDisclaimerPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <CartToast />
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
